// src/screens/AdminScreen.js
import React, { useEffect, useState } from 'react';

export default function AdminScreen() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: '', password: '', role: 'user', store: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // Fetch existing users
  useEffect(() => {
    fetch('api/users', { credentials: 'include' })
      .then(res => res.json())
      .then(setUsers)
      .catch(console.error);
  }, []);

  const handleChange = (field) => (e) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const addUser = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch('api/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Add user failed');
      // Refresh list
      const updated = await fetch('api/users', { credentials: 'include' });
      setUsers(await updated.json());
      setForm({ username: '', password: '', role: 'user', store: '' });
      setShowPassword(false);
    } catch (err) {
      setError('Could not add user');
    }
  };

  const deleteUser = async (uname) => {
    await fetch(`api/users/${uname}`, {
      method: 'DELETE',
      credentials: 'include',
    });
    setUsers(users.filter(u => u.username !== uname));
  };

  return (
    <div className="p-6 max-w-lg mx-auto">
      <h2 className="text-xl font-bold mb-4">Admin: Manage Users</h2>
      <table className="w-full mb-4 table-auto">
        <thead>
          <tr className="bg-gray-200">
            <th className="px-2">Username</th>
            <th className="px-2">Store</th>
            <th className="px-2">Role</th>
            <th className="px-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.username} className="border-b">
              <td className="px-2 py-1">{u.username}</td>
              <td className="px-2 py-1">{u.store}</td>
              <td className="px-2 py-1">{u.role}</td>
              <td className="px-2 py-1">
                {u.username !== 'master' && (
                  <button
                    onClick={() => deleteUser(u.username)}
                    className="text-red-600"
                  >Delete</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="text-lg font-semibold mb-2">Add New User</h3>
      {error && <div className="text-red-600 mb-2">{error}</div>}
      <form onSubmit={addUser} className="space-y-2">
        <input
          placeholder="Username"
          value={form.username}
          onChange={handleChange('username')}
          className="border p-1 w-full"
        />
        {/* New Store/Location field */}
        <input
          placeholder="Store/Location"
          value={form.store}
          onChange={handleChange('store')}
          className="border p-1 w-full"
        />
        {/* Password field with show/hide toggle */}
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            value={form.password}
            onChange={handleChange('password')}
            className="border p-1 w-full pr-12"
          />
          <button
            type="button"
            onClick={() => setShowPassword(prev => !prev)}
            className="absolute inset-y-0 right-0 px-3 text-gray-600"
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>

        <select
          value={form.role}
          onChange={handleChange('role')}
          className="border p-1 w-full"
        >
          <option value="user">user</option>
          <option value="admin">admin</option>
        </select>

        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >Add User</button>
      </form>
    </div>
  );
}
